import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import EnginePage from '../news/EnginePage';
import './ResearchPage.css';

const DOCS = [
  { key: 'benchmarks',           label: 'Benchmarks' },
  { key: 'production-readiness', label: 'Production Readiness' },
  { key: 'context',              label: 'Context' },
];

export default function ResearchPage() {
  const [active, setActive] = useState('thesis');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (active === 'thesis') return;
    setLoading(true);
    fetch(`/api/research/${active}`)
      .then(r => r.json())
      .then(d => { setContent(d.markdown || ''); setLoading(false); })
      .catch(() => { setContent('Could not load document.'); setLoading(false); });
  }, [active]);

  return (
    <div className="research-page">
      <header className="research-header">
        <h1>Research</h1>
        <nav className="research-nav">
          <button className={active === 'thesis' ? 'active' : ''} onClick={() => setActive('thesis')}>
            Market Thesis Engine
          </button>
          {DOCS.map(d => (
            <button
              key={d.key}
              className={active === d.key ? 'active' : ''}
              onClick={() => setActive(d.key)}
            >
              {d.label}
            </button>
          ))}
        </nav>
      </header>
      {active === 'thesis' ? (
        <EnginePage />
      ) : (
        <main className="research-content">
          {loading ? (
            <p className="research-loading">Loading…</p>
          ) : (
            <ReactMarkdown>{content}</ReactMarkdown>
          )}
        </main>
      )}
    </div>
  );
}
